const NoMessage = () => {
  return (
    <div className="flex flex-col items-center mt-10 space-y-3">
      <img src="/images/Empty.png" alt="" className="h-16" />
      <h1 className="font-semibold">No content posted on the board yet</h1>
      <p className="text-sm font-semibold text-gray-500">
        Be the first person to post and get this board going.
      </p>
    </div>
  );
};

export default NoMessage;
